/**
 * Revision History
 * 
 * 12/13/2021   ptkim           Add for ListView column definition, which will be used in ???ListItem.getExportCollection (static)
 */
export enum XCellType {
    None = -1,
    String = 0,
    Date = 1,
    Double = 2,
    Bool = 3,
    StrBool = 4,
    DateTime = 5,
    Password = 6,
    CurAmt,         // adjust decimal based currency of 'cur' column
    DateUtc,
};

export enum XAlignType {
    Left = 0,
    Center = 1,
    Right = 2
};

export const XRowNo: string = "XRowNo";
export const XEmpty: string = "XEmpty";
export interface XExportColumn {
    text:string;
    width:number;
    align:XAlignType;
    type:XCellType;
    dataIndex:string;
    formatString: string;

    col: number;
    visible: boolean;
    moveable: boolean;
    searchIndex: number;
    mandatory: boolean;
    maxLenth: number;
    defaultFocus: boolean;      //pt211103: add
    canBeHidden: boolean;
    resizable: boolean;
    sortable: boolean;
    filterable: boolean;
    filterType: string;
    hiddenInColumnSetup: boolean;
    tooltip: string;
    noNullOrEmptySearch: boolean,
    hasCustomTooltip:boolean,
};

export function Create(obj: any) : XExportColumn {
    return {...{ 
        text: '', 
        width: 100, 
        align: XAlignType.Left, 
        type: XCellType.String, 
        dataIndex: '', 
        formatString: '', 
        col: 0, 
        visible: true, 
        moveable: true, 
        searchIndex: 0, 
        mandatory: false,
        maxLength: 0,
        
        defaultFocus: false,
        canBeHidden: true,
        resizable: true,
        sortable: true,
        filterable: true,
        hiddenInColumnSetup: false,
        noNullOrEmptySearch: false,
    }, ...obj};
};

export function CopyList(srcList: XExportColumn[]):XExportColumn[] {
    let result: XExportColumn[] = [];
    if(srcList) {
        srcList.forEach(x => {
            let newCol = Object.assign({} as XExportColumn, x);
            result.push(newCol);
        });
    }
    return result;
};